import type { StatusTone } from '@vnetwork/ui/data';
import type { AdminRole } from '@/api/organization';

export { formatDate, formatDateTime } from '@/lib/format-date';
export { formatCurrency } from '@/lib/format-currency';

type BadgeTone = 'neutral' | 'primary' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

/** Title-case a kebab/snake status code for display. */
export function titleCase(s: string): string {
  return s.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Badge tone for the company-profile status (Badge has no `muted` tone). */
export function profileBadgeTone(status: string): 'success' | 'warning' | 'neutral' {
  const s = (status ?? '').toLowerCase();
  if (s.includes('customer') || s.includes('active') || s.includes('qualified')) return 'success';
  if (s.includes('prospect') || s.includes('lead') || s.includes('pending')) return 'warning';
  return 'neutral';
}

/** StatusPill tone for a sub-customer / service / invoice lifecycle status. */
export function statusTone(status: string): StatusTone {
  const s = (status ?? '').toLowerCase();
  if (s.includes('active') || s.includes('paid') || s.includes('customer')) return 'success';
  if (s.includes('pending') || s.includes('prospect') || s.includes('unpaid') || s.includes('due'))
    return 'warning';
  if (s.includes('cancel') || s.includes('overdue') || s.includes('suspend')) return 'danger';
  return 'neutral';
}

/** Badge tone for an admin role. */
export function adminRoleTone(role: AdminRole): BadgeTone {
  if (role === 'owner') return 'primary';
  if (role === 'admin') return 'accent';
  return 'neutral';
}
